if (!customElements.get('vt55-steamer-special')) {
  customElements.define('vt55-steamer-special', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.target = 1;
      this.busy = false;
      this.cards = [...this.querySelectorAll('[data-pack]')];
      this.scents = [...this.querySelectorAll('[data-scent]')];
      this.addButton = this.querySelector('[data-add-mix]');
      this.addButton.addEventListener('click', () => this.addMix());
      this.cards.forEach(card => card.addEventListener('click', () => {
        this.target = Number(card.dataset.pack);
        this.cards.forEach(choice => choice.setAttribute('aria-pressed', String(choice === card)));
        const quantity = this.quantityInput();
        if (quantity) {
          quantity.value = String(this.target);
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.updateMix();
      }));
      this.scents.forEach(select => select.addEventListener('change', () => this.updateMix()));
      requestAnimationFrame(() => {
        const quantity = this.quantityInput();
        if (quantity) {
          this.syncQuantity = () => {
            const match = this.cards.find(card => Number(card.dataset.pack) === Number(quantity.value));
            this.cards.forEach(card => card.setAttribute('aria-pressed', String(card === match)));
            if (match) {
              this.target = Number(match.dataset.pack);
              this.updateMix();
            }
          };
          quantity.addEventListener('change', this.syncQuantity);
          this.syncQuantity();
        }
      });
      this.updateMix();
    }
    quantityInput() {
      return document.getElementById(this.dataset.form)?.elements.namedItem('quantity');
    }
    items() {
      return this.scents.filter(select => !select.disabled && Number(select.value) > 0)
        .map(select => ({ id: Number(select.dataset.scent), quantity: Number(select.value) }));
    }
    updateMix() {
      const count = this.items().reduce((sum, item) => sum + item.quantity, 0);
      this.querySelector('[data-count]').textContent = String(count);
      this.querySelector('[data-target]').textContent = String(this.target);
      this.addButton.disabled = this.busy || count !== this.target;
    }
    async addMix() {
      if (this.busy || this.addButton.disabled) return;
      const items = this.items();
      this.busy = true;
      this.updateMix();
      this.scents.forEach(select => select.dataset.wasDisabled = String(select.disabled));
      this.scents.forEach(select => select.disabled = true);
      this.cards.forEach(card => card.disabled = true);
      const error = this.querySelector('[data-mix-error]');
      error.hidden = true;
      this.addButton.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (problem) {
        error.textContent = problem.message || this.dataset.error;
        error.hidden = false;
      } finally {
        this.busy = false;
        this.scents.forEach(select => select.disabled = select.dataset.wasDisabled === 'true');
        this.cards.forEach(card => card.disabled = false);
        this.addButton.removeAttribute('aria-busy');
        this.updateMix();
      }
    }
  });
}
